import { Platform, StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { COLOR, lightGrey } from 'utils/colors';
import { widthPercentageToDP } from 'utils/responsiveness';

const styles = StyleSheet.create({
    container: {
        width: Platform.select({
            web: 490,
            default: widthPercentageToDP(480, 320),
        }),
        marginHorizontal: widthPercentageToDP(16, 44, 72),
        marginBottom: 8,
        alignItems: 'center',
        flexDirection: 'row',
        overflow: 'visible',
    },
    listContainer: {
        paddingHorizontal: 10,
        width: Platform.select({
            web: 360,
            default: widthPercentageToDP(480, 400),
        }),
        height: 42,
    },
    buttonText: {
        marginRight: 16,
        fontSize: 20,
        color: COLOR.highContrast,
        fontFamily: Fonts.main.bold,
    },
    flatList: {
        width: Platform.select({
            web: 470,
            default: widthPercentageToDP(480, 360),
        }),
        height: 40,
    },
    listItemContainer: {
        height: 40,
        width: 40,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 4,
    },
    listItemContainerSelected: {
        borderRadius: 99,
        backgroundColor: 'rgba(238, 238, 238, 0.20)',
    },
    listItemText: {
        fontSize: 16,
        fontFamily: Fonts.main.bold,
        color: COLOR.highContrast,
        textAlign: 'center',
    },
    listItemTextSelected: {
        color: lightGrey(0.7),
    },
    arrowButton: {
        width: 40,
        height: 40,
        paddingHorizontal: 12,
        paddingVertical: 8,
    },
});

export default styles;
